module.exports = __webpack_public_path__ + "static/media/light_icn_map_fermata_scambio_capolinea_selected.5213881a.svg";